import { useQuery } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";

import { IUserScoreReportData } from "../../interfaces/analytics";

const useGetUserScoreReport = (filterQuery: string) => {
    const queryFn = async (): Promise<IUserScoreReportData> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`analytics/user-score-report?${filterQuery}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['user-score-report', filterQuery],
        queryFn,
        retry: 0,
    });
};

export default useGetUserScoreReport;